import React, { useEffect, useState } from 'react'
import {
  HelmetHuntLogo,
} from '../../Constants/achievements'
import { CommunityBadgeAchievement } from './CommunityBadgeAchievement'


export const HelmetHuntCommunityAch: React.FC = () => {
  const pageSlug = window.location.pathname
  const [showActionBtn, setShowActionBtn] = useState<boolean>(false)
  useEffect(() => {
    if (!pageSlug.includes('helmet-hunt-week')) {
      setShowActionBtn(true)
    }
  },[])

  return (
    <CommunityBadgeAchievement
      badgeId={'helmetHunt24Hunter'}
      progressTitle={`Total Participants: `}
      achImg={HelmetHuntLogo}
      btnText={'Join The Hunt'}
      showActionBtn={showActionBtn}
    />
  )
}
